import React from "react";
import {
  FaEnvelope,
  FaFacebookF,
  FaGoogle,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import Navbar from './Navbar'

const Header=()=>{

    return(
<>


{/* Header */}
  <div className="top-bar top-bar-dark">
    <div className="container top-bar__inner">
      <p className="top-bar__note">
        <span className="top-bar__status-dot" aria-hidden="true" />
        <span className="top-bar__note-text">
          India-based web, ecommerce & automation partner
        </span>
      </p>

      <div className="top-bar-contact" aria-label="Contact Plux Infosystems">
        <a href="mailto:info@pluxinfosystems.com" className="contact-item top-bar__action top-bar__email">
          <FaEnvelope aria-hidden="true" />
          <span>info@pluxinfosystems.com</span>
        </a>
        <span className="contact-item top-bar__action top-bar__note-text">Email or chat — no calls</span>
      </div>

      <div className="follow_us" aria-label="Social profiles">
        <span className="top-bar__follow-label">Follow</span>
        <div className="socials">
          <a href="https://www.facebook.com/pluxinfosystems" className="social__item" target="_blank" rel="noopener noreferrer" aria-label="Follow Plux Infosystems on Facebook">
            <FaFacebookF aria-hidden="true" />
          </a>

          <a href="https://twitter.com/chandra353" className="social__item" target="_blank" rel="noopener noreferrer" aria-label="Follow Plux Infosystems on Twitter">
            <FaTwitter aria-hidden="true" />
          </a>

          <a href="https://www.linkedin.com/company/plux-infosystems-private-limited/mycompany/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="social__item" aria-label="Follow Plux Infosystems on LinkedIn">
            <FaLinkedinIn aria-hidden="true" />
          </a>

          <a href="https://business.google.com/website/pluxinfosystems" className="social__item" target="_blank" rel="noopener noreferrer" aria-label="View Plux Infosystems on Google">
            <FaGoogle aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  </div>
  <Navbar/>
</>
    )
}

export default Header;